import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { CreateQrCodeParam } from "features/shared/core/shared.params";
import {
  createQrCodeResponse,
  createQrCodeRepository,
} from "features/shared/data/repository/shared.repository";

export enum CreateQrCodeState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: CreateQrCodeState;
  message: string;
}

const initialState: InitialState = {
  status: CreateQrCodeState.initial,
  message: "",
};

export const createQrCode = createAsyncThunk(
  "createQrCode",
  async (param: CreateQrCodeParam, { rejectWithValue }) => {
    try {
      const response: createQrCodeResponse = await createQrCodeRepository(
        param
      );
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const createQrCodeSlice = createSlice({
  name: "createQrCode",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createQrCode.pending, (state) => {
        state.status = CreateQrCodeState.inProgress;
      })
      .addCase(createQrCode.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;

          state.status = CreateQrCodeState.success;
          state.message = message;
        }
      })
      .addCase(createQrCode.rejected, (state, action) => {
        state.status = CreateQrCodeState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectcreateQrCode = (state: RootState) => state.createQrCode;

export default createQrCodeSlice.reducer;
